module.exports = __webpack_public_path__ + "static/media/awardsbackground.59bbcbbe.jpg";